const imageSizes = {
  small: { width: 640, height: 360 },
  large: { width: 1600, height: 900 },
} as const;

/** 按预览用途缩小七牛图片，保留比例及无法安全改写的外部、签名和自定义处理地址。 */
export function itineraryPreviewImageUrl(source: string, size: keyof typeof imageSizes): string {
  let url: URL;
  try {
    url = new URL(source);
  } catch {
    return source;
  }
  if (!/^https?:$/.test(url.protocol) || url.hostname !== "pic.yishulvxing.com"
    || url.username || url.password || url.port) return source;

  // 只替换单一尺寸/质量指令；其余查询可能参与签名或承载水印等处理，保持原样。
  if (url.search && !/^\?imageView2\/[0-5](?:\/(?:w|h)\/\d+|\/q\/\d+!?)*$/.test(url.search)) return source;

  const { width, height } = imageSizes[size];
  // 七牛普通 q/100 仍受原图质量修正值限制，感叹号才表示强制满质量。
  url.search = `imageView2/2/w/${width}/h/${height}/q/100!`;
  return url.toString();
}
